<template>
  <div class="page-header d-print-none">
    <div class="container-xl">
      <div class="row g-2 align-items-center">
        <div class="col">
          <ClientOnly>
            <div class="page-pretitle">Your games</div>
            <h2 class="page-title text-capitalize d-inline-block">
              {{ source }}
              <!-- <Icon
              size="12"
              class="text-muted ms-1"
              style="width: 1rem; transform: translateY(2px)">
              ChevronDown
            </Icon> -->

              <b-dropdown v-if="false" style="overflow: visible; min-width: 240px">
                <span class="dropdown-header">This is your complete library</span>

                <NuxtLink to="/library" class="dropdown-item">
                  <span class="d-none nav-link-icon d-md-none d-lg-inline-block">
                    <Icon name="tabler:layout-dashboard" size="17" width="1.5" class="text-muted" />
                  </span>
                  <span class="nav-link-title">Your library</span>
                  <small class="ms-auto text-secondary me-1">
                    {{ format.num($app.count.library) }}
                  </small>
                </NuxtLink>

                <NuxtLink
                  v-if="$auth.config.favorites"
                  to="/library/favorites"
                  class="dropdown-item pe-2">
                  <span class="d-none nav-link-icon d-md-none d-lg-inline-block">
                    <Icon name="tabler:heart" size="17" width="1.5" class="text-muted" />
                  </span>
                  <span class="nav-link-title">Favorites</span>
                </NuxtLink>

                <NuxtLink
                  v-for="(state, i) in pinnedStates"
                  :key="'state' + i"
                  :to="'/library/' + state.slug"
                  class="dropdown-item ps-3">
                  <span
                    class="status-dot ms-0 me-4"
                    :style="{ 'background-color': state.color || '' }"
                    style="transform: translateX(1px)"></span>

                  <span class="nav-link-title">{{ state.name }}</span>
                  <small class="ms-auto text-secondary me-1">
                    {{ format.num(stateStore.count(state.id)) }}
                  </small>
                </NuxtLink>

                <div v-if="unPinnedStates.length > 0" class="dropdown-item">
                  <div style="width: 30px">
                    <Icon name="tabler:layout-dashboard" size="18" class="text-muted" width="1.5" />
                  </div>

                  <span>Other states</span>

                  <span class="text-muted ms-auto">
                    <Icon name="tabler:caret-right-filled" size="14" />
                  </span>
                  <b-dropdown placement="right-start" style="overflow: visible; min-width: 240px">
                    <NuxtLink
                      v-for="(state, i) in unPinnedStates"
                      :key="'state' + i"
                      :to="'/library/' + state.slug"
                      class="dropdown-item px-2">
                      <div class="content d-flex align-items-center w-100 px-1">
                        <span
                          class="status-dot ms-1 me-4"
                          :style="{ 'background-color': state.color || '' }"></span>

                        <span class="me-4">
                          {{ state.name }}
                        </span>

                        <small class="ms-auto text-secondary me-1">
                          {{ format.num(stateStore.count(state.id)) }}
                        </small>
                      </div>

                      <!-- <div class="d-flex justify-center" style="width: 30px">
                <Icon name="tabler:home" v-if="isFav(state.name)" style="color: red; fill: pink">Heart</Icon>
                <span
                  v-else
                  class="badge"
                  :style="{ 'background-color': state.color || '' }"></span>
              </div>

              <span class="pe-3">
                {{ state.name }}
              </span>
              <tippy class="text-muted ms-auto cursor-help" :content="state.description">
                <Icon>HelpCircleFilled</Icon>
              </tippy> -->
                      <!-- <span class="badge bg-primary text-primary-fg ms-auto">12</span> -->
                    </NuxtLink>
                  </b-dropdown>
                </div>

                <div
                  v-if="$auth.config.pinned || $auth.config.hidden"
                  class="dropdown-divider"></div>

                <NuxtLink
                  v-if="$auth.config.pinned"
                  to="/library/pinned"
                  class="dropdown-item pe-2">
                  <span class="d-none nav-link-icon d-md-none d-lg-inline-block">
                    <Icon name="tabler:bookmark" size="17" width="1.5" class="text-muted" />
                  </span>
                  <span class="nav-link-title">Pinned games</span>
                </NuxtLink>

                <NuxtLink
                  v-if="$auth.config.hidden"
                  to="/library/hidden"
                  class="dropdown-item pe-2">
                  <span class="d-none nav-link-icon d-md-none d-lg-inline-block">
                    <Icon name="tabler:eye-off" size="17" width="1.5" class="text-muted" />
                  </span>
                  <span class="nav-link-title">Hidden games</span>
                </NuxtLink>

                <!-- <NuxtLink to="/library" class="dropdown-item">
                Library
                <small class="text-secondary ms-auto me-0">
                  {{ format.num($app.count.library) }}
                </small>
              </NuxtLink>
              <NuxtLink to="/journal" class="dropdown-item">Journal</NuxtLink>
              <div class="dropdown-divider"></div>
              <NuxtLink to="/account/me" class="dropdown-item">Account</NuxtLink> -->
              </b-dropdown>
            </h2>
          </ClientOnly>
        </div>
        <div class="col-auto ms-auto">
          <!-- <div class="text-secondary mt-1 text-right" style="text-align: right">
            {{ format.num($app.count.library) }} games
            <br />
            <span class="text-muted" style="zoom: 0.8">(0.19 seconds)</span>
          </div> -->
        </div>
      </div>
    </div>
  </div>

  <div class="page-body">
    <div class="container-xl">
      <search-interface></search-interface>
    </div>
  </div>
</template>

<script>
/**
 * @file:    \pages\library.vue
 * @desc:    ...
 * -------------------------------------------
 * Created Date: 18th December 2023
 * Modified: 15th February 2026 - 17:28:49
 **/

export default {
  data() {
    return {}
  },

  computed: {
    ...mapStores(useDataStore, useStateStore),
    ...mapState(useStateStore, ['states', 'pinnedStates', 'unPinnedStates']),

    source() {
      const slug = this.$route.params?.slug[0] || null
      if (['pinned', 'hidden', 'favorites'].includes(slug)) return slug

      const state = this.states.find((state) => state.slug == slug)
      return state ? state.name : 'Library'
    },
  },
}
</script>
